import clsx from "clsx";

import { STATUS_LABELS, type TicketStatus } from "../types";

/**
 * Colour carries meaning here, so each status also has a distinct label -- the
 * badge must stay readable for anyone who cannot separate the hues.
 */
const STYLES: Record<TicketStatus, string> = {
  open: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-300",
  closed: "bg-surface-2 text-muted-on-tint",
};

export function StatusBadge({ status }: { status: TicketStatus }) {
  return (
    <span
      className={clsx(
        "rounded px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide",
        STYLES[status],
      )}
    >
      {STATUS_LABELS[status]}
    </span>
  );
}
